const DEFAULT_SIGNATURE_FONT_OPTIONS = [{ id: 2, fontFamily: 'Homemade Apple', label: 'Homemade Apple' }];

export default DEFAULT_SIGNATURE_FONT_OPTIONS;
